import { render } from "./WelcomeHeaderComponent.vue?vue&type=template&id=1f620e96"
import script from "./WelcomeHeaderComponent.vue?vue&type=script&lang=js"
export * from "./WelcomeHeaderComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__